<template>
<!--  <section class="approveListBoxPa posiab" :style="{-->
<!--      top: boxTop,-->
<!--    }">-->
<!--    <qx-card title="待我处理">-->
<!--      <span slot="titleRight" class="primary cur" @click="toAllApprove">查看所有</span>-->
<!--      <section-->
<!--        class="listBox transition"-->
<!--        v-infinite-scroll="getData"-->
<!--        v-qx-full-h="{-->
<!--          tar: 'height',-->
<!--          height: delHeight,-->
<!--        }"-->
<!--      >-->
<!--        <section class="noData" v-show="tableData.data.length === 0 && !tableData.hasNext">暂无数据</section>-->
<!--        <ApproveItem v-for="item in tableData.data" :key="item.id" :approveData="item" @del='del'/>-->
<!--        <section class="isBottom" v-show="tableData.data.length !== 0 && !tableData.hasNext">已经到底了</section>-->
<!--      </section>-->
<!--    </qx-card>-->
<!--  待我处理放置概览菜单内，暂时隐藏工作台，恢复工作台菜单时用上方注释代码及methods里的方法-->
  <qx-card title="待我处理" style="height:278px">
    <span slot="titleRight" class="primary cur" @click="toAllApprove">查看所有</span>
    <section
        class="listBox transition"
    >
      <section class="noData" v-show="tableData.data.length === 0 && !tableData.hasNext">暂无数据</section>
      <ApproveItem v-for="item in tableData.data" :key="item.id" :approveData="item" @del='del'/>
      <section class="isBottom" v-show="tableData.data.length !== 0 && !tableData.hasNext">已经到底了</section>
    </section>
  </qx-card>
<!--  </section>-->
</template>

<script>
import {
  waitApproveList,
} from 'api';
import ApproveItem from './approveItem';
import ws from '@qx/mixin/ws';
export default {
  components: {
    ApproveItem,
  },
  mixins: [ws],
  data () {
    return {
      boxTop: 0,
      delHeight: 185, // 高度计算减值
      tableData: {
        loading: false,
        count: 10,
        page: 1,
        data: [],
        hasNext: true,
      },
    };
  },
  methods: {
    handleWsMsg (msg) { // 接收信息
      if (msg.status === 0) { // 待处理 - 添加
        this.tableData.data.unshift(msg);
      } else { // 已处理/已失效 - 删除
        for (let i = 0; i < this.tableData.data.length; i++) {
          if (this.tableData.data[i].id === msg.id) {
            this.tableData.data.splice(i, 1);
            break;
          }
        }
      }
      // 删除之后如果当前数据为空 且 还有数据，请求下一页
      if (this.tableData.data.length === 0 && this.tableData.hasNext) {
        this.getData();
      }
    },
    del (item) {
      for (let i = 0; i < this.tableData.data.length; i++) {
        if (this.tableData.data[i].id === item.id) {
          this.tableData.data.splice(i, 1);
          break;
        }
      }
      // 删除之后如果当前数据为空 且 还有数据，请求下一页
      if (this.tableData.data.length === 0 && this.tableData.hasNext) {
        this.getData();
      }
    },
    toAllApprove () {
      this.jump({
        label: '待我处理',
        url: '/manage/index/workspace/allApprove?type=approve',
      });
    },
    async getData () {
      if (!this.tableData.hasNext || this.tableData.loading) {
        return;
      }
      this.tableData.loading = true;
      const res = await waitApproveList({
        status: 0,
        count: this.tableData.count,
        page: this.tableData.page,
      });
      this.tableData.page++;
      this.tableData.hasNext = res.hasNext;
      this.tableData.data.push(...res.items);
      this.$nextTick(() => {
        this.tableData.loading = false;
      });
    },
    handleBoxPosition () {
      const scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 99) {
        this.boxTop = scrollTop - 99 + 'px';
        this.delHeight = 72;
      } else {
        this.boxTop = 0;
        this.delHeight = 171 - scrollTop;
      }
    },
  },
  created () {
    this.getData();
    // window.addEventListener('scroll', this.handleBoxPosition);
  },
  // destroyed () {
  //   window.removeEventListener('scroll', this.handleBoxPosition);
  // },
};
</script>

<style scoped lang="scss">
.approveListBoxPa {
  top: 0;
  right: 0;
}
.listBox {
  width: 312px;
  overflow: auto;
  height:210px;
  .noData {
    padding-top: 100px;
    text-align: center;
  }
  .isBottom {
    text-align: center;
  }
  //&::-webkit-scrollbar {
  //  /*滚动条整体样式*/
  //  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  //  height: 1px;
  //}
  //&::-webkit-scrollbar-thumb {
  //  /*滚动条里面小方块*/
  //  border-radius: 10px;
  //  // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  //  background: #999;
  //}
//  &::-webkit-scrollbar-track {
//    /*滚动条里面轨道*/
//    // box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
//    border-radius: 10px;
//    background: #e0e0e0;
//  }
}
</style>
